import Patterns from '../patterns.js';

export default [
  {
    name: 'group',
    label: {
      cs: 'Skupina',
      en: 'Group',
    },
    type: 'string',
    pattern: Patterns.ONLY_LOWER_CASE_WITH_NUMBERS,
    patternErrorMessage: Patterns.ONLY_LOWER_CASE_WITH_NUMBERS_MESSAGE,
    minLength: 1,
    maxLength: 2,
  },
  {
    name: 'stream',
    label: {
      cs: 'Stream',
      en: 'Stream',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'czechTelevision',
    label: {
      cs: 'Česká televize',
      en: 'Czech Television',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'photogallery',
    label: {
      cs: 'Fotogalerie',
      en: 'Photogallery',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'highlights',
    label: {
      cs: 'Highlights',
      en: 'Highlights',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'note.cs',
    label: {
      cs: 'Poznámka [CS]',
      en: 'Note [CS]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'note.en',
    label: {
      cs: 'Poznámka [EN]',
      en: 'Note [EN]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
];
